// extracted by mini-css-extract-plugin
export default {"massObjectController":"MassObjectController_massObjectController__of98a"};